import * as React from 'react';
const internalStyles = require('./MorningstarRating.pcss');

interface IProps {
    stars?: number;
}

export class MorningstarRating extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
    }

    render() {
        let mStarRating = this.props.stars || 0;
        if (mStarRating === 0) {
            return <span>n/a</span>;
        }
        return (
            <img style={{display:"inline", width:"auto"}} height="9px" src={require(`../../images/${mStarRating}-star.svg`)} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/MorningstarRating/MorningstarRating.tsx